module.exports = __webpack_public_path__ + "img/制御工学3_6_5.b529bc74.png";